import { RootState } from "../store";

export const imagesSelector = (state: RootState) => state.images;
